import { render, staticRenderFns } from "./LeasesHistory.vue?vue&type=template&id=7889f32b&scoped=true&"
import script from "./LeasesHistory.vue?vue&type=script&lang=js&"
export * from "./LeasesHistory.vue?vue&type=script&lang=js&"
import style0 from "./LeasesHistory.vue?vue&type=style&index=0&id=7889f32b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7889f32b",
  null
  
)

export default component.exports